import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Aid = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Aid' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,22 L23,22 L23,6 L1,6 L1,22 Z M8,6 L16,6 L16,2 L8,2 L8,6 Z M8,14 L16,14 M12,10 L12,18' />
  </StyledIcon>
);
